import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["result"];

  onStateChange({ currentTarget }) {
    $.ajax({
      url: `${this.baseUrl}/payers/${currentTarget.value}`,
      dataType: "html",
      context: this,
      success: data => {
        // Check if we should bypass the popup and redirect directly
        const temp = document.createElement("div");

        temp.innerHTML = data;
        const statePopper = temp.querySelector("[data-controller='state-popper']");
        const bypassUrl = statePopper?.dataset?.statePopperBypassUrlValue;

        if (bypassUrl) {
          window.location.href = bypassUrl;
          return;
        }

        this.resultTarget.innerHTML = data;
      },
    });
  }

  get baseUrl() {
    return this.data.get("base-url");
  }
}
